import { request } from '@umijs/max';
import {
  CustomerRechargeParamsType,
  wechatPayType,
  wechatRechargePramsType,
} from '@/pages/Payment/interface';

export const queryWechatPay = async (data: wechatPayType) => {
  return request('/api/property/api/senke/Wxchat/wechatPay', {
    method: 'POST',
    data,
  });
};

/**
 * @desc 公众号充值
 * @param data
 */
export const queryWechatRecharge = async (data: wechatRechargePramsType) => {
  return request('/api/property/payment/administration/recharge', {
    method: 'POST',
    data,
  });
};

/**
 * @desc 用户在公众号内充值
 * @param data
 */
export const queryCustomerRecharge = async (data: CustomerRechargeParamsType) =>
  request('/api/community/trade/recharge', {
    method: 'POST',
    data,
  });
